export default __webpack_public_path__ + "static/media/ic-info.20267414.20267414.svg";